var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.4949 6.66298C10.866 6.99896 11.4366 6.9676 11.7694 6.59294C12.1022 6.21827 12.0711 5.64217 11.7 5.30619L6.74343 0.714145C6.40056 0.403721 5.88118 0.403721 5.53831 0.714145L0.466643 5.41038C0.095541 5.74636 0.0644779 6.32246 0.397263 6.69713C0.730047 7.0718 1.30066 7.10316 1.67176 6.76717L6.14087 2.61647L10.4949 6.66298Z","fill":"#1C2E45","fillOpacity":"0.6"}));
}

ArrowUp.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
